module.exports = __webpack_public_path__ + "img/trademark-icon.8a5a74a3.png";